import React from "react";
import styled, { withTheme } from "styled-components";
import StyledElement from "./StyledElement";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import LoadingSpinner from "../../ui-library/LoadingSpinner/LoadingSpinner";
import { useTranslation } from "react-i18next";

const EntriesWrapper = styled.div`
  flex: 1 !important;

  @media (max-width: 1279px) {
    padding: 0;
  }
`;

const StyledPaper = styled.div`
  background-color: ${(props) => props.theme?.white};
  color: ${(props) => props.theme?.fg};
  border-radius: 12px;
  padding: 10px;
`;

const StyledHeader = styled.div`
  padding: 1rem 2rem 0.5rem 1rem;
  margin-bottom: 0;
  border-bottom: 0px solid rgba(0, 0, 0, 0.125);
  font-size: 19px;
  font-weight: 600;
  color: ${(props) => props.theme?.nero};

  @media (max-width: 647px) {
    font-size: 14px;
  }
`;

const StyledDivButton = styled.div`
  padding: 1rem 1rem 0rem 0rem;
  margin-bottom: 0;

  @media (max-width: 647px) {
    & > button {
      font-size: 14px;
      padding: 0.25rem;
    }
  }
`;

const StyledBody = styled.div`
  padding: 0.5rem 1rem 2rem 1.5rem;
  overflow-y: auto;
  max-height: 250px;
  margin-top: 5px;
  margin-right: 20px;
`;

const StyledSpan = styled.span`
  flex: 1;
  padding: 0;
`;

const StyledDiv = styled.div`
  min-height: 2em;
  text-align: justify;
  border-radius: 5px;
  margin-top: 10px;
  background-color: ${(props) => props.theme?.whiteSmoke};
  padding-top: 0.2em;
  display: flex;
  align-items: center;
`;

const CompleteIcon = styled.i`
  color: ${(props) =>
    props?.isFastingIcon
      ? props?.theme?.blueMagenta2
      : props?.theme?.lightGreen};
  font-size: 20px;
  margin-right: 20px;
  flex: 0;
`;

const EntriesList = (props) => {
  const {
    id,
    title,
    elements,
    actionButtonText,
    actionButton,
    isFastingDay,
    actionButtonInactive,
    onEdit,
    canEdit,
    loadingEntries,
    loadingEntriesError,
    showActionButton,
    onDelete,
    canDelete,
    completeDay,
    timeFormat = "12h",
  } = props;

  const { t } = useTranslation();

  return (
    <EntriesWrapper
      id={`${id}-entries-list`}
      data-testid={`${id}-entries-list`}
    >
      <StyledPaper>
        <div className="d-flex">
          <StyledHeader className="">{title}</StyledHeader>

          {showActionButton && (
            <StyledDivButton className="ms-auto">
              <PrimaryButton
                size={"sm"}
                id={`${id}-action-btn`}
                data-testid={`${id}-action-btn`}
                onClick={() => actionButton(elements)}
                disabled={actionButtonInactive}
              >
                {actionButtonText}
              </PrimaryButton>
            </StyledDivButton>
          )}
        </div>
        <StyledBody className="align-middle">
          {loadingEntries && !loadingEntriesError && <LoadingSpinner />}
          {!isFastingDay &&
            elements?.map(
              (entry, index) =>
                entry.title &&
                entry.title !== "undefined" && (
                  <div key={index}>
                    <StyledElement
                      key={index}
                      index={index}
                      element={entry}
                      completed={completeDay}
                      actionButtonInactive={actionButtonInactive}
                      onEdit={(entry) => onEdit(entry)}
                      canEdit={canEdit}
                      onDelete={(entry) => onDelete(entry)}
                      canDelete={canDelete}
                      timeFormat={timeFormat}
                    />
                  </div>
                )
            )}
          {isFastingDay && (
            <StyledDiv data-testid="fasting-day" className="row">
              <CompleteIcon
                className="fas fa-check-circle mx-3 px-0"
                isFastingIcon={true}
              />{" "}
              <StyledSpan>{t("appText.fastingDay")}</StyledSpan>
            </StyledDiv>
          )}
          {!isFastingDay &&
            (loadingEntriesError || !elements || elements.length === 0) && (
              <StyledDiv data-testid="no-records" className="row ps-2">
                {t("appText.noRecords")}
              </StyledDiv>
            )}
        </StyledBody>
      </StyledPaper>
    </EntriesWrapper>
  );
};

export default withTheme(EntriesList);
